import { ReactNode } from 'react';
import { FormProvider, FormProviderProps } from '../FormProvider';
import { FormControls } from '../FormControls';
import { FormContext_State } from '../FormContext';

export interface FormProps<Steps extends string, State, Action>
	extends FormProviderProps<Steps, State, Action> {
	children: ReactNode;
	name: string;
	action?: string;
	className?: string;
}

const Form = <
	Steps extends string,
	State extends FormContext_State<Steps>,
	Action,
>(
	props: FormProps<Steps, State, Action>,
) => {
	const {
		children,
		onSubmit,
		reducer,
		defaultState,
		initializeState,
		graph,
		className,
	} = props;

	return (
		<FormProvider<Steps, State, Action>
			onSubmit={onSubmit}
			reducer={reducer}
			defaultState={defaultState}
			initializeState={initializeState}
			graph={graph}
			className={className}
		>
			{children}
			<FormControls<State, Action, Steps> />
		</FormProvider>
	);
};

export default Form;
